import React from 'react';

  function Notfound(data) {
    
   return (
    <>
      { data==false ? 
        <div className='not-found'>
            Not Found
        </div> 
          : <></>
      }
    </>
  )
}

export default  Notfound
